var lazySearching = false;

var lazyButton = document.getElementById('lazyloader');
    if (lazyButton) {
        lazyButton.addEventListener('click', (event) => showmoreproducts(event));
    }

window.addEventListener('popstate', (event) => {
    if (event.state && event.state.lazy) {
        fetchProducts(window.location, true, false);
    }
});

function showmoreproducts(event) {
    const lazyLoader = document.getElementById('lazyloader');
    const href = lazyLoader.getAttribute('href');
    fetchProducts(href, false, true);
    event.preventDefault();
}

function fetchProducts(href, all, pushState) {
    if (lazySearching === true) return;
    lazySearching = true;
    var lazyLoader = document.getElementById('lazyloader');
    lazyLoader.classList.add("active");
    const max = parseInt(lazyLoader.getAttribute('data-max'));

    fetch(href + (href.indexOf('?') !== -1 ? '&' : '?'),
        {
            method: 'GET',
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache',
                'lazy': 'true',
                'all': all
            }
        })
        .then(response => response.json())
        .then(data => {
            lazySearching = false;
            const prodList = document.getElementsByClassName('product-list')[1];
            if (all || (!all && !pushState)) {
                prodList.innerHTML = '';
            }
            if (prodList) {
                if (data.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null)
                {
                    gtag("event", "view_item_list", data.dataLayer);
                }

                prodList.innerHTML += data.view;
                window.__litium.bootstrapComponents();
                const url = new URL(href);
                const nextPage = getNextPage(url);
                lazyLoader.classList.remove("active");
                if (nextPage > max) {
                    lazyLoader.remove()
                } else {
                    url.searchParams.set("page", nextPage);
                    lazyLoader.setAttribute('href', decodeURIComponent(url));
                }
                if (pushState) {
                    window.history.pushState({ page: nextPage - 1 }, null, href);
                }
            }
        });
}

function getNextPage(url) {
    var hasPage = url.searchParams.has("page");
    return hasPage ? parseInt(url.searchParams.get("page")) + 1 : 2;
}